import * as _ from 'lodash';
import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields';

const operatableIds = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_trees/operatable_ids`),
    params: param,
  });
};

const selectableCompaniesList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_trees/selectable_companies_list`),
    params: param,
  });
};

// TODO: 今使われてない？そうなら消す
/* eslint-disable no-unused-vars */
const readableIds = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_trees/readable_ids`),
    params: param,
  });
};

// api :GET, '/api/private/fields/:field_id/field_trees/:id/tree_jobs', 'ツリーID所属職種情報取得API'
const treeJobs = (fieldId, fieldTreeId, param, useDefaultCatch = true) => {
  return requestWithToken(
    {
      method: 'GET',
      url: path.concat(`/${fieldId}/field_trees/${fieldTreeId}/tree_jobs`),
      params: param,
    },
    useDefaultCatch
  );
};

const treeJobList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_trees/job_list`),
    params: param,
  });
};

// 職長
const treeUsers = (fieldId, fieldTreeId, param, useDefaultCatch = true) => {
  return requestWithToken(
    {
      method: 'GET',
      url: path.concat(`/${fieldId}/field_trees/${fieldTreeId}/tree_users`),
      params: param,
    },
    useDefaultCatch
  );
};

const partnerUserSelfIds = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_trees/partner_user_self_ids`),
  });
};

const levelList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_trees/level_list`),
    params: param,
  });
};

const updateOrder = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/field_trees/update_order`),
    data: param,
  });
};

const allCompanies = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_trees/field_all_companies`),
    params: param,
  });
};

const treeUsersList = (fieldId, fieldTreeId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldId}/field_trees/${fieldTreeId}/field_tree_users/list`
    ),
    params: param,
  });
};

const formStatuses = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_tree_form_statuses/list`),
    params: param,
  });
};

const formStatus = (fieldId, fieldTreeId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldId}/field_trees/${fieldTreeId}/field_tree_form_status`
    ),
    params: param,
  });
};
const show = (fieldId, fieldTreeId, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldId}/field_trees/${fieldTreeId}/field_tree_users/${id}`
    ),
  });
};

const createForemanUser = (fieldId, fieldTreeId, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/field_trees/${fieldTreeId}/field_tree_users`),
    data: param,
  });
};

const updateForemanUser = (fieldId, fieldTreeId, id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(
      `/${fieldId}/field_trees/${fieldTreeId}/field_tree_users/${id}`
    ),
    data: param,
  });
};

const showTree = (fieldId, fieldTreeId) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_trees/${fieldTreeId}`),
  });
};

const update = (fieldId, fieldTreeId, id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(
      `/${fieldId}/field_trees/${fieldTreeId}/field_tree_users/${id}`
    ),
    params: param,
  });
};

const updateFormStatus = (fieldId, fieldTreeId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(
      `/${fieldId}/field_trees/${fieldTreeId}/field_tree_form_status`
    ),
    params: param,
  });
};

const countUnapproved = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_tree_form_statuses/count_unapproved`),
  });
};

/**
 * 体系図 職種一覧
 * @param {object} param
 */
const privateJobsList = param => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/jobs/list`,
    params: param,
  });
};

/**
 * 現場情報と選択したJVの支店情報からメイン元請けを考慮した支店IDを返送する
 * 仕様）
 * 選択した支店のcompany_branch_idとメイン元請けのcompany_branch_idが一致した場合、
 * その値を使用し、メインではなくサブの支店ID（サブ＝メイン元請け企業の別支店の一覧）と支店IDを比較する。
 * 一致した場合は、メイン元請けのcompany_branch_idを使用する。
 * それでも一致しない場合は、選択した値を使用する。
 * 別企業の場合は、施工体系図で操作できないため考慮なし。
 * @param {*} field API（/fields/[現場ID]）現場情報 ＊APIを実行すると必要な情報が揃う
 * @param {*} selectedCompanyBranchId 施工体系図で選択した支店情報
 */
const decideCompanyBranchId = (field, selectedCompanyBranchId) => {
  if (!_.isEmpty(field)) {
    const mainPrimeContractor = field.company; // メイン元請け
    // メイン元請けの支店IDと同じならメイン元請けの支店IDをreturnする
    if (mainPrimeContractor.company_branch_id === selectedCompanyBranchId) {
      return mainPrimeContractor.company_branch_id;
    } else {
      // メイン元請けの支店IDと一致しない場合、サブと支店IDが一致するか確認する
      const jvs = field.jvs;
      const subContractor = _.filter(jvs, jv => {
        return jv.company_branch_id === selectedCompanyBranchId;
      });
      // サブと一致する支店が存在する場合
      if (!_.isEmpty(subContractor)) {
        //メイン元請けと企業IDがいっちするか
        if (mainPrimeContractor.company_id === subContractor[0].company_id) {
          return mainPrimeContractor.company_branch_id;
        } else {
          return subContractor[0].company_branch_id;
        }
      } else {
        return selectedCompanyBranchId;
      }
    }
  } else {
    return selectedCompanyBranchId;
  }
};

const getUsersOfPartner = (fieldId, fieldTreeId, param) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/fields/${fieldId}/field_trees/${fieldTreeId}/field_tree_users/list`,
    params: param,
  });
};

const requestApprovalAll = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/fields/${fieldId}/field_trees/request_approval_all`,
    params: param,
  });
};

const checkDuplicate = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_trees/check_duplicate`),
    params: param,
  });
};

const createIntegrate = (fieldId, fieldTreeId, data) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(
      `/${fieldId}/field_trees/${fieldTreeId}/field_tree_users/create_integrate`
    ),
    data,
  });
};

export const FieldTreeService = {
  operatableIds,
  selectableCompaniesList,
  treeJobs,
  treeJobList,
  treeUsers,
  partnerUserSelfIds,
  levelList,
  updateOrder,
  allCompanies,
  treeUsersList,
  formStatuses,
  formStatus,
  show,
  createForemanUser,
  updateForemanUser,
  showTree,
  update,
  updateFormStatus,
  countUnapproved,
  decideCompanyBranchId,
  privateJobsList,
  getUsersOfPartner,
  requestApprovalAll,
  checkDuplicate,
  createIntegrate,
};

export default FieldTreeService;



// WEBPACK FOOTER //
// ./src/services/FieldTrees.js